<template>
  <Dropdown ref="dropdown" append-to-body>
    <template #button="{ open }">
      <button
        type="button"
        class="p-2 rounded-full bg-transparent hover:bg-gray-200 focus:outline-none"
        @click="open"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="12" r="1" />
          <circle cx="12" cy="19" r="1" />
          <circle cx="12" cy="5" r="1" />
        </svg>
      </button>
    </template>

    <div
      class="origin-top-right absolute right-0 mt-2 max-w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <div class="py-1">
        <button
          type="button"
          class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-red-700 hover:bg-red-100 hover:text-red-900"
          role="menuitem"
          @click="handleDelete"
        >
          Delete
        </button>
      </div>
    </div>
  </Dropdown>
</template>

<script>
import { deleteProductApi } from '@/api/clients/admin';

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleDelete() {
      this.$modal.show({
        component: () => import('./DeleteProductDialog.vue'),
        props: {
          action: async (productId) => {
            try {
              await deleteProductApi(productId);

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          product: this.product,
        },
        on: {
          deleted: () => {
            this.$emit('deleted');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
